// @see https://dev.to/drbragg/handling-service-worker-updates-in-your-vue-pwa-1pip
export default {
    data () {
        return {
            refreshing: false,
            registration: null,
            updateExists: false,
        }
    },

    created () {
        // Listen for our custom event from the SW registration
        document.addEventListener('serviceWorkerUpdated', this.updateAvailable, { once: true })

        // Prevent multiple refreshes
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            if (this.refreshing) return

            this.refreshing = true
            window.location.reload()
        })
    },

    methods: {
        // Store the SW registration, so we can send it a message.
        // We use `updateExists` to control whatever alert, toast, dialog, etc. we want to use.
        // To alert the user there is an update they need to refresh for
        updateAvailable (event) {
            this.registration = event.detail
            this.updateExists = true
        },

        // Called when the user clicks the update button
        refreshApp () {
            this.updateExists = false

            // Make sure we only send a 'skip waiting' message if the ServiceWorker is waiting
            if (!this.registration || !this.registration.waiting) {
                console.info('mixin:: ServiceWorker is not waiting.')
                window.location.reload()
                return
            }

            // Send message to ServiceWorker to skip the waiting and activate the new ServiceWorker
            this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
        },
    },
}
